// Page scroll lock shared by every sheet, modal and lightbox.
//
// On phones the document never scrolls: `.page-content` inside #mob-shell is the scroller,
// so `document.body.style.overflow = 'hidden'` (the old per-page approach) locked nothing.
// The lock is a class on <html>; site.css turns it into overflow:hidden on html, body and
// .page-content plus overscroll-behavior:none so the root cannot rubber-band.
//
// Locks are keyed by owner so a stray extra unlock (an Escape handler that closes every
// sheet, for example) never releases a lock that another open layer still holds.

const LOCK_CLASS = 'doc-scroll-locked';
const owners = new Set<string>();

export function lockScroll(owner = 'default'): void {
    owners.add(owner);
    document.documentElement.classList.add(LOCK_CLASS);
}

export function unlockScroll(owner = 'default'): void {
    owners.delete(owner);
    if (owners.size === 0) document.documentElement.classList.remove(LOCK_CLASS);
}

/** True while any layer holds the lock. */
export function isScrollLocked(): boolean {
    return owners.size > 0;
}
